import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of, map, catchError } from 'rxjs';
import { UserResolved } from '../models/User';
import { AccountService } from './account.service';
import { OAuthServiceService } from './o-auth-service.service';
import { TenantService } from './tenant.service';
import { UserProfileService } from './user-profile.service';
import { UserProfileForCreation } from '../models/UserProfileForCreation';

@Injectable({
  providedIn: 'root'
})
//export class UserprofileResolverService {
  export class UserprofileResolverService implements Resolve<string>{

  

    constructor(private accountService: AccountService,
      private tenantService:TenantService,
      private userProfileService: UserProfileService,
      private oauthService: OAuthServiceService) { }
  
      // resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): UserResolved | Observable<UserResolved> | Promise<UserResolved> {
      resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): string | Promise<string> {
      
      const id = route.paramMap.get('id') as string;    
  
      console.log("============> userprofile-resolver: id = ", id);
      if (id === '') {
        const message = `No User id was provided: ${id}`;
        console.log(message);
        //return of({ userDto: null, error: message });
        return id;
      }
      return id;
      // this.userProfileService.getUserById(id).subscribe({
      //   next:(userProfile: UserProfileForCreation) => {       
      //     return of(new UserResolved)
      //   }
      // }

      // return this.userProfileService.getUserById(id)
      //   .pipe(map(userProfile => ({userprofile: UserProfileForCreation})),
      //   catchError(error => {
      //     const message = `Retrieval error: ${error}`;
      //     console.error(message);
      //     //return of({ projectDto: null, error: message });
      //     return of(new UserProfileForCreation)
      //   }));

      // if (tenantdb === this.tenantService.SystemManagerAbbreviation ||  tenantdb === String(null) || tenantdb === '') {
        // return this.accountService.getUser(id)
        //   .pipe(map(userDto => ({userDto: userDto})),
        //     catchError(error => {
        //       const message = `Retrieval error: ${error}`;
        //       console.error(message);
        //       //return of({ projectDto: null, error: message });
        //       return of(new UserResolved)
        //     }));
      // }
      // else {
      //   return this.tenantService.getUser(tenantdb, id)
      //   .pipe(map(userDto => ({userDto: userDto})),
      //   catchError(error => {
      //     const message = `Retrieval error: ${error}`;
      //     console.error(message);
      //     //return of({ projectDto: null, error: message });
      //     return of(new UserResolved)
      //   }));
      // }
    }
  }
